<section>
  <div class="container">
    <div class="row">
      <form [formGroup]="form" class="col-12 col-md-12 col-lg-12">
        <div class="col-md-12">
          <div class="user-dashboard-info-box">
            <div class="form-row flex-column">
              <div class="section-title-02 mb-2">
                <h4>Basic Information</h4>
              </div>
            </div>
            <app-image-cropper buttonTitle="Upload Photo" [shouldUploadFile]="true"
              (imageCropperEvent)="handleFileChangeEvent($event)">
            </app-image-cropper>
            <div class="form-row" *ngIf="uploadStatus">
              <p class="text-danger pl-3">{{uploadStatus}}</p>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Profile Title *</label>
                <input type="text" class="form-control" formControlName="title"
                  [class.is-invalid]="(form.controls['title']?.errors || form.controls['title']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>First Name *</label>
                <input type="text" class="form-control" formControlName="firstName"
                  [class.is-invalid]="(form.controls['firstName']?.errors || form.controls['firstName']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>Last Name *</label>
                <input type="text" class="form-control" formControlName="lastName"
                  [class.is-invalid]="(form.controls['lastName']?.errors || form.controls['lastName']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>City *</label>
                <input type="text" class="form-control" formControlName="city"
                  [class.is-invalid]="(form.controls['city']?.errors || form.controls['city']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>Country *</label>
                <select class="form-control basic-select" formControlName="country"
                  [class.is-invalid]="(form.controls['country']?.errors || form.controls['country']?.errors?.required)">
                  <option *ngFor="let country of lookupStore.countries | async" [ngValue]="country.id">
                    {{country.name}}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Gender *</label>
                <select class="form-control basic-select" formControlName="gender"
                  [class.is-invalid]="(form.controls['gender']?.errors || form.controls['gender']?.errors?.required)">
                  <option *ngFor="let gender of lookupStore.genders | async" [ngValue]="gender.id">{{gender.name}}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6 select-border float-left">
                <label>Experience *</label>
                <select class="form-control basic-select" formControlName="experience"
                  [class.is-invalid]="form.controls['experience']?.errors?.required">
                  <option *ngFor="let experience of experienceYears" [ngValue]="experience.value">
                    {{experience.displayValue}}</option>
                </select>
              </div>
              <div class="form-group col-md-6 select-border float-left">
                <label>Education *</label>
                <select class="form-control basic-select" formControlName="educationLevel"
                  [class.is-invalid]="(form.controls['educationLevel']?.errors || form.controls['educationLevel']?.errors?.required)">
                  <option *ngFor="let educationLevel of lookupStore.educationLevels | async"
                    [ngValue]="educationLevel.id">{{educationLevel.value}}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Languages *</label>
                <ng-select [items]="languagesList" bindValue="id" bindLabel="name" [multiple]="true"
                  placeholder="Select all your professional Languages" [compareWith]="compareWith"
                  (change)="onSelectionChange($event)" formControlName="languages" class="custom" required>
                  <div>
                  </div>
                  <ng-template ng-header-tmp let-items="items">
                    <input type="checkbox" [checked]="selectAll" (change)="toggleCheckAll($event)" />
                  </ng-template>
                  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:2">
                      <span class="ng-value-label">{{item.name}}</span>
                      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 2">
                      <span class="ng-value-label">{{items.length - 2}} more...</span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" /> {{item.name}}
                  </ng-template>
                </ng-select>
              </div>
              <div class="form-group col-md-6 select-border">
                <label>Primary Sector</label>
                <select class="form-control basic-select" formControlName="sector">
                  <option *ngFor="let sector of lookupStore.sectors | async" [ngValue]="sector.id">{{sector.name}}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Rate/Salary - $ (US-Dollars)</label>
                <input type="number" class="form-control" formControlName="salary">
              </div>
              <div class="form-group col-md-2">
                <label>Rate Type</label>
                <select class="form-control basic-select" formControlName="salaryType">
                  <option *ngFor="let salaryType of lookupStore.salaryTypes | async" [ngValue]="salaryType.id">
                    {{salaryType.value}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="user-dashboard-info-box">
            <div class="form-group mb-0">
              <h4 class="mb-3">Contact Information <span class="header-subtext">(Information provided here is for
                  Manzoul use only, and it won’t appear on your public profile).</span></h4>
              <div class="form-row">
                <div class="form-group col-md-6 datetimepickers">
                  <label>Date of birth</label>
                  <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [maxDate]="maxDOB" [minDate]="minDOB"
                      formControlName="dob" ngbDatepicker #d="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Phone*</label>
                  <input type="text" class="form-control" formControlName="phone"
                    [class.is-invalid]="form.controls['phone']?.errors || form.controls['phone']?.errors?.required">
                </div>
                <div class="form-group col-md-12">
                  <label>Email *</label>
                  <input type="email" class="form-control" formControlName="email" readonly
                    [class.is-invalid]="(form.controls['email']?.errors || form.controls['email']?.errors?.required)">
                </div>
                <div class="form-group mb-0 col-md-12">
                  <label>Address *</label>
                  <input type="text" class="form-control" formControlName="address"
                    [class.is-invalid]="(form.controls['address']?.errors || form.controls['address']?.errors?.required)">
                </div>
              </div>
            </div>
          </div>
          <div class="text-end">

            <a class="btn btn-md btn-primary" [routerLink]="" (click)="saveProfile()">Save</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>